import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=64806f96&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=64806f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64806f96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64806f96')) {
      api.createRecord('64806f96', component.options)
    } else {
      api.reload('64806f96', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=64806f96&scoped=true&", function () {
      api.rerender('64806f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ga8o4zVvNt5H/JS/comp/DateRangeExt.vue"
export default component.exports